import { inject } from '@angular/core';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import {
  CanActivateFn,
  ActivatedRouteSnapshot,
  UrlSegment,
} from '@angular/router';
import { CmsPageEnum } from '@models/copy/cms-page-map.model';
import { CmsService } from '@services/cms/cms.service';

export const cmsPathGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const cmsService = inject(CmsService);

  // SSR guard: only run setTimeout in browser
  const platformId = inject(PLATFORM_ID);

  // Trigger request to CMS if path has not been retrieved.
  // setTimeout required to handle loading nested content,
  // ensuring each path has a network request
  if (isPlatformBrowser(platformId)) {
    setTimeout(() => {
      const cmsPath =
        route && route.data
          ? (route.data['cmsPath'] as CmsPageEnum)
          : undefined;
      if (cmsPath) {
        cmsService.pathRequestSig.set(cmsPath);
      } else {
        const urlRaw = route?.url as UrlSegment[] | undefined;
        const segments: UrlSegment[] = Array.isArray(urlRaw) ? urlRaw : [];
        const joined = segments
          .map((segment) => segment.path)
          .filter(Boolean)
          .join('/');
        const path = joined ? `/${joined}` : CmsPageEnum.HOME;
        cmsService.pathRequestSig.set(path);
      }
    }, 0);
  }

  return true;
};
